module.exports = __webpack_public_path__ + "static/media/audits_small.dba718cb.jpg";